<div class="archive-page">
  <div class="archive-main">
    <div class="container-xxl archive-results">
      <header class="archive-head">
        <div>
          <h1>Archivio artistico</h1>
          <p>Le schede del catalogo artistico della Misericordia di Borgo San Lorenzo.</p>
        </div>
      </header>

      <form class="archive-search" [formGroup]="filterForm" (submit)="$event.preventDefault(); searchArticles()">
        <div class="search-head">
          <label for="title">Ricerca testuale</label>
          @if (hasActiveSearch) {
            <button class="search-reset" type="button" (click)="resetSearch()">Azzera</button>
          }
        </div>
        <div class="search-row">
          <input id="title" type="search" placeholder="Cosa stai cercando?" formControlName="title">
          <button type="submit">Cerca</button>
        </div>
      </form>

      <div class="archive-stats">
        <span><strong>{{ totalResults }}</strong> {{ totalResults === 1 ? 'risultato' : 'risultati' }}</span>
        <span>{{ totalPages }} {{ totalPages === 1 ? 'pagina' : 'pagine' }}</span>
      </div>

      @if (articles.length > 0) {
        <ng-container *ngTemplateOutlet="pagesNav; context: { label: 'Paginazione, in alto' }"></ng-container>

        <app-card-archive [articlesA]="articles" [type]="2" (navigate)="navigate($event)"></app-card-archive>

        <ng-container *ngTemplateOutlet="pagesNav; context: { label: 'Paginazione, in basso' }"></ng-container>
      } @else {
        <p class="archive-empty">La ricerca non ha prodotto risultati.</p>
      }
    </div>
  </div>

  <ng-template #pagesNav let-label="label">
    <nav class="archive-pages" [attr.aria-label]="label">
      <div class="page-controls">
        <button type="button" aria-label="Pagina precedente" [disabled]="currentPageIndex === 1"
          (click)="goToPage(currentPageIndex - 1)">
          <i class="bi bi-chevron-left" aria-hidden="true"></i>
        </button>
        <div class="page-list" (scroll)="onPageListScroll($event)">
          @for (token of pageTokens; track $index) {
            @if (token === 'ellipsis') {
              <span class="page-gap" aria-hidden="true">…</span>
            } @else {
              <button type="button" [class.is-active]="currentPageIndex === token"
                [attr.aria-current]="currentPageIndex === token ? 'page' : null"
                (click)="goToPage(token)">{{ token }}</button>
            }
          }
        </div>
        <button type="button" aria-label="Pagina successiva" [disabled]="currentPageIndex === totalPages"
          (click)="goToPage(currentPageIndex + 1)">
          <i class="bi bi-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
      <label class="page-size">
        <span class="page-size-label">
          <span>Elementi</span>
          <span>per pagina</span>
        </span>
        <select (change)="setItemsPerPage($event)">
          @for (size of pageSizeOptions; track size) {
            <option [value]="size" [selected]="size === itemsPerPage">{{ size }}</option>
          }
        </select>
      </label>
    </nav>
  </ng-template>
</div>
